const ProcurementIndexFrom = [
  {
    modelvalue: "",
    title: "产品线名称：",
    inputtype: "select",
    inputflag: true,
    fontSize: 14,
    color: "#333333",
    lableheight: 20,
    X: false,
    types: "",
    placeholder: "请选择",
    width: 210,
    height: 32,
    disabled: false,
    marginLeft: 20,
    marginTop: 30,
    displayVal: "inline-block",
    fontWeightVal: 500,
    options: [],
    event: "invClassChange"
  },
  {
    title: "二级销售：",
    inputtype: "select",
    SelectType: "SelectAll",
    checkedSelect: false,
    modelvalue: "",
    inputflag: true,
    fontSize: 14,
    color: "#333333",
    lableheight: 20,
    X: false,
    types: "",
    placeholder: "请选择",
    AllName: "全国",
    width: 210,
    height: 32,
    disabled: false,
    marginLeft: 130,
    marginTop: 30,
    displayVal: "inline-block",
    fontWeightVal: 500,
    options: [
      {
        key: "1ssdd",
        value: "东区",
      },
      {
        key: "2ssss",
        value: "西区",
      },
      {
        key: "3ssss",
        value: "北区",
      },
    ],
    multiple: true,
    collapseTags: true,
    event: "LargeArea",
  },
  {
    modelvalue: "",
    title: "三级销售：",
    inputtype: "select",
    collapseTags: true,
    multiple: true,
    inputflag: true,
    fontSize: 14,
    color: "#333333",
    lableheight: 20,
    X: false,
    types: "",
    placeholder: "请选择",
    width: 210,
    height: 32,
    disabled: false,
    marginLeft: 180,
    marginTop: 30,
    displayVal: "inline-block",
    fontWeightVal: 500,
    options: [],
    event: "ThirdDealerChange",
  },
  {
    modelvalue: "",
    title: "销售员：",
    inputtype: "select",
    collapseTags: true,
    multiple: true,
    inputflag: true,
    fontSize: 14,
    color: "#333333",
    lableheight: 20,
    X: false,
    types: "",
    placeholder: "请选择",
    width: 210,
    height: 32,
    disabled: false,
    marginLeft: 50,
    marginTop: 30,
    displayVal: "inline-block",
    fontWeightVal: 500,
    options: [],
  },
  {
    modelvalue: "",
    key: "",
    title: "经销商：",
    inputtype: "input",
    inputflag: true,
    fontSize: 14,
    color: "#333333",
    lableheight: 20,
    X: false,
    types: "text",
    placeholder: "请输入",
    width: 200,
    height: 32,
    disabled: false,
    marginLeft: 145,
    marginTop: 23,
    displayVal: "inline-block",
    fontWeightVal: 500,
    focus: "distributorChange"
  },

  {
    StartTime: '',
    EndTime: '',
    title: "时间：",
    inputtype: "dateSection",
    selectFlag: true,
    types: "month",
    inputflag: true,
    Startdisabled: false,
    EndDisabled: true,
    displayVal: "inline-block",
    widthLeft: 120,
    widthRight: 120,
    heightLeft: 32,
    heightRight: 32,
    marginLeft: 145,
    marginTop: 30,
    fontSize: 14,
    color: "#333333",
    lableheight: 20,
    pickerOptionsFlagStart: "Month",
    X: false,
    fontWeightVal: 500,
  },
];
export default ProcurementIndexFrom;
